import { Input, Pagination } from 'antd';
import { IPOMessage } from '@hylaa-npm/ipod';
import React, { ReactNode, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import leftIcon from '@/images/common/page/left.svg';
import notLeftIcon from '@/images/common/page/not-left.svg';
import rightIcon from '@/images/common/page/right.svg';
import notRightIcon from '@/images/common/page/not-right.svg';
import { PageWrap } from './style';
interface IPageProps {
	offset: number; // 偏移量， 总的第几条
	total: number;
	take: number; // 每页多少条
	handleChange: (offset: number, take: number) => void; // 回调方法
	noShowTotal?: boolean;
}

const PaginItem = (props: IPageProps) => {
	let { total, take, offset, handleChange, noShowTotal } = props;
	const { t } = useTranslation();
	const [current, setCurrent] = useState<number>(1);
	const [toSize, setToSize] = useState<string>('');

	useEffect(() => {
		if (take) {
			let newCurrent = Math.floor(offset / take) + 1;
			setCurrent(newCurrent);
		}
	}, [offset, take]);

	useEffect(() => {
		const totalPage = Math.ceil(total / take);

		if (toSize) {
			if (Number(toSize) > totalPage) {
				IPOMessage.warning(`${t('common.currentPage')}${totalPage}${t('common.page')}`);
				setToSize(totalPage.toString());
			}
			if (Number(toSize) <= 0) {
				setToSize('1');
			}
		}
	}, [toSize]);

	const pageChange = (page: number, pageSize?: number) => {
		setCurrent(page);
		let offset = take * page - take;
		if (offset <= total) {
			handleChange(offset, take);
		}
	};
	const itemRender = (currentPage: number, type: string, originalElement: ReactNode) => {
		if (type === 'prev') {
			return (
				<div className="page-pagin-icon">
					<img src={currentPage === 0 ? notLeftIcon : leftIcon} />
				</div>
			);
		}
		if (type === 'next') {
			return (
				<div className="page-pagin-icon">
					<img src={current !== Math.ceil(total / take) ? rightIcon : notRightIcon} />
				</div>
			);
		}
		return originalElement;
	};
	return (
		<PageWrap>
			<div className="align-item">
				<Pagination
					itemRender={itemRender}
					current={current}
					total={total}
					pageSize={take}
					showQuickJumper={false}
					showSizeChanger={false}
					onChange={pageChange}
				/>
				<div className="to-wrap">
					{t('common.go')}
					<Input
						value={toSize}
						type="number"
						onChange={(e) => setToSize(e.target.value)}
						onPressEnter={() => toSize && pageChange(parseInt(toSize), take)}
					/>
					{t('common.page')}
				</div>
			</div>
			{!noShowTotal && (
				<div className="total-wrap">
					{' '}
					{t('common.total')}
					{total}
					{t('common.strip')}
				</div>
			)}
		</PageWrap>
	);
};

export default PaginItem;
